import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Host,
  Input,
  Optional,
  ViewChild,
} from '@angular/core';
import { uniqueId } from '@sama/micro-dash';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { delayOnMicrotaskQueue } from '../../misc-utilities/misc-utils';
import { HorizontalFormComponent } from './horizontal-form.component';

@Component({
  selector: 'h3-horizontal-form-row',
  templateUrl: './horizontal-form-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HorizontalFormRowComponent implements AfterViewChecked {
  @ViewChild('content') private contentRef!: ElementRef;
  firstInputId$: Observable<string | undefined>;
  private _labelWidth?: number;
  private _contentWidth?: number;
  private firstInputIdSubject$ = new BehaviorSubject<string | undefined>(
    undefined,
  );

  constructor(
    @Host()
    @Optional()
    public form: HorizontalFormComponent,
  ) {
    this.firstInputId$ = this.firstInputIdSubject$.pipe(
      distinctUntilChanged(),
      delayOnMicrotaskQueue(),
    );
  }

  get contentWidth() {
    return this._contentWidth || 12 - this.labelWidth;
  }

  @Input({ required: true })
  set contentWidth(value: number) {
    this._contentWidth = value;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering -- there is a contradiction between this rule and @typescript-eslint/adjacent-overload-signature rule
  get labelWidth() {
    const width = this._labelWidth || this.form.labelWidth;
    if (!width) {
      throw new Error(
        '`h3-horizontal-form-row` must either be nested within an' +
          ' `h3-horizontal-form` in the same template or you must specify' +
          ' `[labelWidth]` explicitly',
      );
    }
    return width;
  }

  @Input({ required: true })
  set labelWidth(value: number) {
    this._labelWidth = value;
  }

  ngAfterViewChecked() {
    const $input = $(this.contentRef.nativeElement)
      .find(':input:not(button,[type="checkbox"],[type="radio"])')
      .first();
    if ($input.length === 0) {
      this.firstInputIdSubject$.next(undefined);
      return;
    }

    let id = $input.attr('id');
    if (!id) {
      id = uniqueId('h3-form-control-input-');
      $input.attr('id', id);
    }
    this.firstInputIdSubject$.next(id);
  }
}
